import { render, staticRenderFns } from "./BusinessAnnualReturnsTab.vue?vue&type=template&id=ac130548&scoped=true&"
import script from "./BusinessAnnualReturnsTab.vue?vue&type=script&lang=js&"
export * from "./BusinessAnnualReturnsTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac130548",
  null
  
)

export default component.exports